var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5035 7.23868C13.6988 7.43394 13.6988 7.75053 13.5035 7.94579L10.2032 11.2461C9.81272 11.6366 9.17955 11.6366 8.78902 11.2461L5.48873 7.94579C5.29347 7.75053 5.29347 7.43394 5.48873 7.23868C5.68399 7.04342 6.00058 7.04342 6.19584 7.23868L9.00008 10.0429L9.00008 0.5C9.00008 0.223858 9.22393 0 9.50008 0C9.77622 0 10.0001 0.223858 10.0001 0.5L10.0001 10.035L12.7964 7.23868C12.9917 7.04342 13.3083 7.04342 13.5035 7.23868ZM1 6.5C1 6.22386 0.776142 6 0.5 6C0.223858 6 0 6.22386 0 6.5V13C0 14.3807 1.11929 15.5 2.5 15.5H16.5C17.8807 15.5 19 14.3807 19 13V6.5C19 6.22386 18.7761 6 18.5 6C18.2239 6 18 6.22386 18 6.5V13C18 13.8284 17.3284 14.5 16.5 14.5H2.5C1.67157 14.5 1 13.8284 1 13V6.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/DownloadWhite.06325bf350893cc7d45b7d93786efc25.svg";
export { ForwardRef as ReactComponent };